
<template>
       <div>
           <Fileuploading/>
       </div>
</template>

<script>
import Fileuploading from '../components/Fileuploading.vue';

export default {
    components: {
        Fileuploading
    }
};
</script>
<style scoped>


</style>